import './App.css'
import _ from 'lodash'
import { useState, useEffect } from 'react'
import { ThemeProvider } from 'styled-components';
import Layout from './components/Layout'
import tempData from './data/temperature.json'
import gravData from './data/gravity.json'
import atmoData from './data/atmosphere.json'
import sizeData from './data/size.json'
import commonElements from './data/common.json'
import rareElements from './data/rare.json'
import orbitalData from './data/orbital.json'
import featureData from './data/features.json'
import mysteryData from './data/mysteries.json'
import hooksData from './data/hooks.json'
import poiData from './data/poi.json'
import hourData from './data/hours.json'
import dryFeatures from './data/dryfeatures.json'
import gasFeatures from './data/gasfeatures.json'
import gasHooks from './data/gashooks.json'
import gasMysteries from './data/gasmysteries.json'
import themes from './data/themecolors.json'
import GlobalStyles from './globalStyles.css'
import Loading from './components/Loading'
import { numberImages } from './components/TerrestrialNumbers'
import {
  rndmzViewbox,
  rndmColors,
  rollOnTable,
  rndPlanetName,
  rndPlanetNumber,
  rndGraphData,
  rndText,
  doubleRoll,
  hasWater
}
from './helpers/random'

const rollPlanet = (theme, currentPlanet = null) => {
  let orbital, feature, mystery, hook, placeOne, placeTwo
  let starNum, planetNum, moonNum, textureNum, extraMoons, gateNum,
  elevatorNum, shipNum, anomalyNum, alertNum, stationNum
  orbital = feature = mystery = hook = placeOne = placeTwo = ''
  starNum = planetNum = moonNum = textureNum = extraMoons = gateNum =
  elevatorNum = shipNum = anomalyNum = alertNum = stationNum = 1

  if (currentPlanet) {
    orbital = currentPlanet.placesOfInterest.orbital
    placeOne = currentPlanet.placesOfInterest.poi1
    placeTwo = currentPlanet.placesOfInterest.poi2
    feature = currentPlanet.wardenInfo.feature
    mystery = currentPlanet.wardenInfo.mystery
    hook = currentPlanet.wardenInfo.hook

    const previousImageValues = currentPlanet.imageValues

    if (previousImageValues.starNum < 4) {
      starNum = previousImageValues.starNum + 1
    } else {
      starNum = 1
    }
    if (previousImageValues.poiNums.planetNum < _.size(numberImages)) {
      planetNum = previousImageValues.poiNums.planetNum + 1
    } else {
      planetNum = 1
    }
    if (previousImageValues.poiNums.moonNum < 12) {
      moonNum = previousImageValues.poiNums.moonNum + 1
    } else {
      moonNum = 1
    }
    if (previousImageValues.poiNums.extraMoons < 12) {
      extraMoons = previousImageValues.poiNums.extraMoons + 1
    } else {
      extraMoons = 1
    }
    if (previousImageValues.poiNums.gateNum < 2) {
      gateNum = previousImageValues.poiNums.gateNum + 1
    } else {
      gateNum = 1
    }
    if (previousImageValues.poiNums.elevatorNum < 3) {
      elevatorNum = previousImageValues.poiNums.elevatorNum + 1
    } else {
      elevatorNum = 1
    }
    if (previousImageValues.poiNums.alertNum < 5) {
      alertNum = previousImageValues.poiNums.alertNum + 1
    } else {
      alertNum = 1
    }
    if (previousImageValues.poiNums.shipNum < 3) {
      shipNum = previousImageValues.poiNums.shipNum + 1
    } else {
      shipNum = 1
    }
    if (previousImageValues.poiNums.stationNum < 5) {
      stationNum = previousImageValues.poiNums.stationNum + 1
    } else {
      stationNum = 1
    }
    if (previousImageValues.poiNums.anomalyNum < 4) {
      anomalyNum  = previousImageValues.poiNums.anomalyNum  + 1
    } else {
      anomalyNum  = 1
    }
    if (previousImageValues.textureNum.num < 8) {
      textureNum = previousImageValues.textureNum.num + 1
    } else {
      textureNum = 1
    }
  }

  const planetName = {
    name: rndPlanetName(),
    number: rndPlanetNumber(),
  }

  const planetData = {
    size: rollOnTable(sizeData),
    temperature: rollOnTable(tempData),
    gravity: rollOnTable(gravData),
    atmosphere: rollOnTable(atmoData),
  }

  const hourRange = rollOnTable(hourData)

  const scanResults = {
    avgTemp: _.random(planetData.temperature.min_value, planetData.temperature.max_value),
    surfaceGravity: _.round(_.random(planetData.gravity.min_value, planetData.gravity.max_value), 2),
    commonElements: doubleRoll(commonElements),
    rareElement: rollOnTable(rareElements),
    diameter: _.random(planetData.size.min_value, planetData.size.max_value),
    hoursPerDay: _.random(hourRange.min_value, hourRange.max_value),
    graphData: rndGraphData()
  }

  const watery = hasWater()
  const gaseousDiameterGravRatio = 1/30000;
  const currentDiameterGravRatio = scanResults.surfaceGravity/scanResults.diameter
  const gaseous = (scanResults.diameter > 15000 && currentDiameterGravRatio < gaseousDiameterGravRatio ) ? true : false

  const terrestialPlaceOne = rollOnTable(poiData, placeOne)
  const nextSet = _.filter((poiData), function(datum) {return datum.description !== terrestialPlaceOne.description})
  const terrestialPlaceTwo = rollOnTable(nextSet, placeTwo)

  const placesOfInterest = {
    poi1: terrestialPlaceOne,
    poi2: terrestialPlaceTwo,
    orbital: rollOnTable(orbitalData, orbital)
  }

  const newMystery = gaseous ? rollOnTable(gasMysteries, mystery) : rollOnTable(mysteryData, mystery)
  const newHook = gaseous ? rollOnTable(gasHooks, hook) : rollOnTable(hooksData, hook)
  let newFeature
  if (gaseous) {
    newFeature = rollOnTable(gasFeatures, feature)
  } else if (watery) {
    newFeature = rollOnTable(featureData, feature)
  } else {
     newFeature = rollOnTable(dryFeatures, feature)
  }

  const wardenInfo = {
    feature: newFeature,
    mystery: newMystery,
    hook: newHook,
    random: [rndText(), rndText(), rndText()]
  }

  const imageValues = {
    planetViewbox: rndmzViewbox(),
    starNum: starNum,
    planetColors: rndmColors(theme),
    orbitalTag: placesOfInterest.orbital.image,

    hasWater: watery,
    poiNums:
      {
        planetNum: planetNum,
        moonNum: moonNum,
        extraMoons: extraMoons,
        gateNum: gateNum,
        elevatorNum: elevatorNum,
        alertNum: alertNum,
        anomalyNum: anomalyNum,
        shipNum: shipNum,
        stationNum: stationNum,
        ringNums: {
          "inner": {
            diameter: _.random(1300, 1600),
            width: _.random(120, 200)
          },
          "middle": {
            diameter: _.random(1300, 1600),
            width: _.random(120, 200)
          },
          "outer": {
            diameter: _.random(1500, 1900),
            width: _.random(80, 250)
          }
        }
      },
    textureNum:
      {
        num: textureNum,
        randomX: _.random(-325, -425),
        randomY: _.random(-325, -425),
        zoom: _.random(1800, 2000)
      }
  }

  return {planetName, planetData, scanResults, placesOfInterest, wardenInfo, gaseous, imageValues}
}

function App() {
  const [theme, setTheme] = useState(themes.green)
  const [currentPlanet, setCurrentPlanet] = useState(rollPlanet(theme))
  const [wardenView, setWardenView] = useState(true)
  const [downloading, setDownloading] = useState(false)
  const [loading, setLoading] = useState(true)
  const [savedColors, setSavedColors] = useState();
  const [blockade, setBlockade] = useState(false);

  useEffect(() => {
    setTimeout(() => setLoading(false), 2000)
  }, [])

  const newPlanet = (theme) => {
    setBlockade(false)
    setCurrentPlanet(rollPlanet(theme, currentPlanet))
  }

  const cycleColor = () => {
    switch (theme.primaryColor) {
      case themes.green.primaryColor:
        setTheme(themes.amber)
        break
      case themes.amber.primaryColor:
        setTheme(themes.grey)
        break
      case themes.grey.primaryColor:
        setTheme(themes.red)
        break
      case themes.red.primaryColor:
        setTheme(themes.blue)
        break
      case themes.blue.primaryColor:
        setPrinterTheme()
        setSavedColors(currentPlanet.imageValues.planetColors)
        break
      default:
        const resetImageValues = {...currentPlanet.imageValues, planetColors: savedColors}
        setCurrentPlanet({...currentPlanet, imageValues: resetImageValues})
        setTheme(themes.green)
    }
  }

  const setPrinterTheme = () => {
    setTheme(themes.printer)
    const printerValues = {...currentPlanet.imageValues, planetColors: {
      "background": "#000000",
      "ocean": "#FFFFFF",
      "texture": "#979797",
      "highlight": "#000000",
      "id": "printer"
    }}
    setCurrentPlanet({...currentPlanet, imageValues: printerValues})
  }

  const setGameBoy = () => {
    if (theme.primaryColor !== themes.printer.primaryColor && theme.primaryColor !== themes.gameboy.primaryColor) {
      setSavedColors(currentPlanet.imageValues.planetColors)
    }
    setTheme(themes.gameboy)
    const gameboyValues = {...currentPlanet.imageValues, planetColors: {
      "background": "#88c070",
      "ocean": "#346856",
      "texture": "#e0f8d0",
      "highlight": "#e0f8d0",
      "id": "gameboy"
    }}
    setCurrentPlanet({...currentPlanet, imageValues: gameboyValues})
  }

  const setBlockadeStatus = () => {
    setBlockade(!blockade)
  }

  const rerollPoi = (number) => {
    let newPlaces
    const poi1 = currentPlanet.placesOfInterest.poi1;
    const poi2 = currentPlanet.placesOfInterest.poi2;
    const nextSet = _.filter((poiData), function(datum) {return datum.description !== poi1.description && datum.description !== poi2.description})

    switch (number) {
      case 'one':
        const newOrbital =  rollOnTable(orbitalData, currentPlanet.orbital)
        const newImage = {...currentPlanet.imageValues, orbitalTag: newOrbital.image}
        newPlaces = {...currentPlanet.placesOfInterest, orbital: newOrbital}
        setCurrentPlanet({...currentPlanet,imageValues: newImage, placesOfInterest: newPlaces})
        break
      case 'two':
        const newPoi1 =  rollOnTable(nextSet, currentPlanet.poi1)
        newPlaces = {...currentPlanet.placesOfInterest, poi1: newPoi1}
        setCurrentPlanet({...currentPlanet, placesOfInterest: newPlaces})
        break
      case 'three':
        const newPoi2 =  rollOnTable(nextSet, currentPlanet.poi2)
        newPlaces = {...currentPlanet.placesOfInterest, poi2: newPoi2}
        setCurrentPlanet({...currentPlanet, placesOfInterest: newPlaces})
        break
      default: return
    }
  }

  const rerollWarden = (type) => {
    let newWardenInfo
    switch (type) {
      case "HOOK":
        const currentHook = currentPlanet.wardenInfo.hook
        const newHook = currentPlanet.gaseous ? rollOnTable(gasHooks, currentHook) : rollOnTable(hooksData, currentHook)
        newWardenInfo = {...currentPlanet.wardenInfo, hook: newHook}
        break
      case "MYSTERY AND PHENOMENA":
        const currentMystery = currentPlanet.wardenInfo.mystery
        const newMystery = currentPlanet.gaseous ? rollOnTable(gasMysteries, currentMystery) : rollOnTable(mysteryData, currentMystery)
        newWardenInfo = {...currentPlanet.wardenInfo, mystery: newMystery}
        break
      default:
        const currentFeature = currentPlanet.wardenInfo.feature
        let newFeature
        if (currentPlanet.gaseous) {
          newFeature = rollOnTable(gasFeatures, currentFeature)
        } else if (currentPlanet.watery) {
          newFeature = rollOnTable(featureData, currentFeature)
        } else {
          newFeature = rollOnTable(dryFeatures, currentFeature)
        }
        newWardenInfo = {...currentPlanet.wardenInfo, feature: newFeature}
      }
      setCurrentPlanet({...currentPlanet, wardenInfo: newWardenInfo})
  }

  const rerollName = () => {
    const newName = {
      name: rndPlanetName(),
      number: rndPlanetNumber(),
    }
    setCurrentPlanet({...currentPlanet, planetName: newName})
  }

  const rerollData = (type) => {
    let newData
    let newScanResults
    switch (type) {
      case "size":
        const currentSize = currentPlanet.planetData.size
        const newSize = rollOnTable(sizeData, currentSize)
        const newDiameter = _.random(newSize.min_value, newSize.max_value)
        newData = {...currentPlanet.planetData, size: newSize}
        const newSizePlanet = {...currentPlanet, planetData: newData}
        newScanResults = {...currentPlanet.scanResults, diameter: newDiameter}
        newSizePlanet.scanResults = newScanResults
        setCurrentPlanet(newSizePlanet)
        break
      case "temperature":
        const currentTemp = currentPlanet.planetData.temperature
        const newTemp = rollOnTable(tempData, currentTemp)
        const newAvgTemp = _.random(newTemp.min_value, newTemp.max_value)
        newData = {...currentPlanet.planetData, temperature: newTemp}
        const newTempPlanet = {...currentPlanet, planetData: newData}
        newScanResults = {...currentPlanet.scanResults, avgTemp: newAvgTemp}
        newTempPlanet.scanResults = newScanResults
        setCurrentPlanet(newTempPlanet)
        break
      case "gravity":
        const currentGrav = currentPlanet.planetData.gravity
        const newGrav = rollOnTable(gravData, currentGrav)
        const newSurfaceGravity = _.round(_.random(newGrav.min_value, newGrav.max_value), 2)
        newData = {...currentPlanet.planetData, gravity: newGrav}
        const newGravPlanet = {...currentPlanet, planetData: newData}
        newScanResults = {...currentPlanet.scanResults, surfaceGravity : newSurfaceGravity}
        newGravPlanet.scanResults = newScanResults
        setCurrentPlanet(newGravPlanet)
        break
      case "elements":
        const newCommonElements = doubleRoll(commonElements)
        const newRareElement = rollOnTable(rareElements)
        newScanResults = {...currentPlanet.scanResults, commonElements: newCommonElements}
        newScanResults.rareElement = newRareElement
        setCurrentPlanet({...currentPlanet, scanResults: newScanResults})
        break
      case "hours":
        const hourRange = rollOnTable(hourData)
        const newHours = _.random(hourRange.min_value, hourRange.max_value)
        newScanResults = {...currentPlanet.scanResults, hoursPerDay: newHours}
        setCurrentPlanet({...currentPlanet, scanResults: newScanResults})
        break
      default:
      // case "atmosphere":
        const currentAtmo = currentPlanet.planetData.atmosphere
        const newAtmo = rollOnTable(atmoData, currentAtmo)
        newData = {...currentPlanet.planetData, atmosphere: newAtmo}
        setCurrentPlanet({...currentPlanet, planetData: newData})
        break
      }
  }

  const toggleWardenView = (currentView) => {
    setWardenView(!currentView)
    if (blockade) {
      setBlockade(false)
    }
  }

  return (
    <ThemeProvider theme={theme} >
      <GlobalStyles />
        <>
        {loading === false ? (
          <Layout
            newPlanet={newPlanet}
            downloading={downloading}
            setDownloading={setDownloading}
            wardenView={wardenView}
            setWardenView={toggleWardenView}
            currentPlanet={currentPlanet}
            cycleColor={cycleColor}
            theme={theme}
            setGameBoy={setGameBoy}
            blockade={blockade}
            setBlockadeStatus={setBlockadeStatus}
            rerollWarden={rerollWarden}
            rerollPoi={rerollPoi}
            rerollName={rerollName}
            rerollData={rerollData}
          />
          ) : (
            <Loading />
          )
        }
        </>
    </ThemeProvider>
  );
}

export default App;
